// import React, { useCallback, useEffect, useState } from 'react';
// import { getMonthlyInvoice } from '../inventoryApi';
// import {
//   COLORS, SEMANTIC, Card, SectionHeader, SecondaryButton,
//   formatCurrency, MONTH_OPTIONS,
// } from './InventoryUIKit';
// import InvoiceFilters from './InvoiceFilters';
// import InvoiceTable from './InvoiceTable';
// import InvoiceSummaryCards from './InvoiceSummaryCards';

// const normalizeItems = (data) => {
//   if (Array.isArray(data)) return data;
//   if (Array.isArray(data?.items)) return data.items;
//   if (Array.isArray(data?.results)) return data.results;
//   return [];
// };

// /**
//  * MonthlyInvoice
//  *
//  * Subtab of "Inventory Invoices": GET /inventory/invoices/monthly/?month&year
//  * Shows aggregate FIFO cost of every item used across the org for a month.
//  */
// const MonthlyInvoice = ({ pushToast }) => {
//   const now = new Date();
//   const [month, setMonth] = useState(now.getMonth() + 1);
//   const [year, setYear] = useState(now.getFullYear());
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchInvoice = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const result = await getMonthlyInvoice({ month, year });
//       setData(result);
//     } catch (err) {
//       setError(err.response?.data?.message || err.message || 'Failed to load monthly invoice.');
//     } finally {
//       setLoading(false);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handleGenerate = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const result = await getMonthlyInvoice({ month, year });
//       setData(result);
//     } catch (err) {
//       setError(err.response?.data?.message || err.message || 'Failed to load monthly invoice.');
//     } finally {
//       setLoading(false);
//     }
//   }, [month, year]);

//   useEffect(() => { fetchInvoice(); }, [fetchInvoice]);

//   const items = normalizeItems(data);
//   const totalCost = data?.total_cost != null ? Number(data.total_cost) : items.reduce((acc, i) => acc + Number(i.fifo_cost ?? 0), 0);
//   const totalQty = data?.total_quantity_used != null ? Number(data.total_quantity_used) : items.reduce((acc, i) => acc + Number(i.quantity_used ?? 0), 0);
//   const itemCount = data?.number_of_items != null ? Number(data.number_of_items) : items.length;
//   const avgCost = itemCount > 0 ? totalCost / itemCount : 0;

//   const columns = [
//     { key: 'item', label: 'Inventory Item', sortable: true, render: (r) => r.inventory_item_name || r.inventory_item?.item_name || r.item_name || '—' },
//     { key: 'item_code', label: 'Item Code', render: (r) => r.item_code || r.inventory_item?.item_code || '—' },
//     { key: 'quantity_used', label: 'Quantity Used', align: 'right', sortable: true, render: (r) => r.quantity_used ?? 0 },
//     { key: 'fifo_cost', label: 'FIFO Cost', align: 'right', sortable: true, render: (r) => formatCurrency(r.fifo_cost) },
//     {
//       key: 'pct', label: '% of Total Cost', align: 'right',
//       render: (r) => totalCost > 0 ? `${((Number(r.fifo_cost ?? 0) / totalCost) * 100).toFixed(1)}%` : '0.0%',
//     },
//   ];

//   const footer = (
//     <tr style={{ borderTop: `2px solid ${COLORS.mediumGrey}` }}>
//       <td colSpan={3} style={{ padding: '10px 12px', fontWeight: '700', textAlign: 'right', color: COLORS.darkText }}>Grand Total</td>
//       <td style={{ padding: '10px 12px', fontWeight: '700', textAlign: 'right', color: COLORS.darkText }}>{formatCurrency(totalCost)}</td>
//       <td style={{ padding: '10px 12px', fontWeight: '700', textAlign: 'right', color: COLORS.darkText }}>100%</td>
//     </tr>
//   );

//   const monthLabel = MONTH_OPTIONS.find((m) => m.value === month)?.label || month;

//   return (
//     <div className="invoice-printable">
//       <InvoiceFilters
//         month={month}
//         year={year}
//         onMonthChange={setMonth}
//         onYearChange={setYear}
//         onRefresh={fetchInvoice}
//         onGenerate={handleGenerate}
//         loading={loading}
//       />

//       <InvoiceSummaryCards
//         cards={[
//           { title: 'Total Cost', value: formatCurrency(totalCost), icon: '💰', accentColor: COLORS.aquaBlue, loading, error },
//           { title: 'Total Quantity Used', value: totalQty, icon: '📦', accentColor: '#6366f1', loading, error },
//           { title: 'Number of Items', value: itemCount, icon: '🧾', accentColor: COLORS.grassGreen, loading, error },
//           { title: 'Average Cost / Item', value: formatCurrency(avgCost), icon: '📊', accentColor: COLORS.vividPurple, loading, error },
//         ]}
//       />

//       <Card>
//         <SectionHeader
//           title="Monthly Invoice"
//           subtitle={`${monthLabel} ${year}`}
//           accentColor={COLORS.aquaBlue}
//           right={(
//             <div style={{ display: 'flex', gap: '8px' }} className="no-print">
//               <SecondaryButton onClick={() => window.print()}>🖨️ Print</SecondaryButton>
//               <SecondaryButton onClick={() => pushToast?.('PDF export is coming soon.', 'info')}>⬇️ Download PDF</SecondaryButton>
//               <SecondaryButton onClick={() => pushToast?.('Excel export is coming soon.', 'info')}>📊 Export Excel</SecondaryButton>
//             </div>
//           )}
//         />
//         <div style={{ padding: '16px' }}>
//           <InvoiceTable
//             columns={columns}
//             rows={items}
//             loading={loading}
//             error={error}
//             onRetry={fetchInvoice}
//             emptyMessage="No inventory usage recorded for this month."
//             footer={items.length > 0 ? footer : null}
//             rowKey="item_code"
//           />
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default MonthlyInvoice;
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getMonthlyInvoice } from "../inventoryApi";
import {
  COLORS,
  Card,
  SectionHeader,
  SecondaryButton,
  formatCurrency,
  MONTH_OPTIONS,
} from "./InventoryUIKit";

import InvoiceFilters from "./InvoiceFilters";
import InvoiceTable from "./InvoiceTable";
import InvoiceSummaryCards from "./InvoiceSummaryCards";

const normalizeItems = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.results)) return data.results;
  return [];
};

const MonthlyInvoice = ({ pushToast }) => {
  const today = new Date();

  const [month, setMonth] = useState(today.getMonth() + 1);
  const [year, setYear] = useState(today.getFullYear());

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [invoice, setInvoice] = useState(null);

  const fetchInvoice = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const res = await getMonthlyInvoice({
        month,
        year,
      });

      setInvoice(res);
    } catch (err) {
      console.error(err);

      setError(
        err?.response?.data?.message ||
          err.message ||
          "Unable to load invoice."
      );
    } finally {
      setLoading(false);
    }
  }, [month, year]);

  useEffect(() => {
    fetchInvoice();
  }, [fetchInvoice]);

  const items = useMemo(() => normalizeItems(invoice), [invoice]);

  const totalCost =
    invoice?.total_cost != null
      ? Number(invoice.total_cost)
      : items.reduce((sum, item) => sum + Number(item.total_cost || 0), 0);

  const totalQty =
    invoice?.total_quantity_used != null
      ? Number(invoice.total_quantity_used)
      : items.reduce((sum, item) => sum + Number(item.quantity_used || 0), 0);

  const itemCount =
    invoice?.number_of_items != null
      ? Number(invoice.number_of_items)
      : items.length;

  const averageCost = itemCount ? totalCost / itemCount : 0;

  const columns = [
    {
      key: "inventory_item_name",
      label: "Inventory Item",
      sortable: true,
      render: (row) => row.inventory_item_name || "—",
    },
    {
      key: "inventory_item_code",
      label: "Item Code",
      sortable: true,
      render: (row) => row.inventory_item_code || "—",
    },
    {
      key: "quantity_used",
      label: "Quantity Used",
      align: "right",
      sortable: true,
      render: (row) => row.quantity_used,
    },
    {
      key: "total_cost",
      label: "FIFO Cost",
      align: "right",
      sortable: true,
      render: (row) => formatCurrency(row.total_cost),
    },
    {
      key: "percentage",
      label: "% of Total Cost",
      align: "right",
      render: (row) =>
        totalCost
          ? `${(
              (Number(row.total_cost) / totalCost) *
              100
            ).toFixed(1)}%`
          : "0%",
    },
  ];

  const footer = (
    <tr
      style={{
        borderTop: `2px solid ${COLORS.mediumGrey}`,
      }}
    >
      <td
        colSpan={3}
        style={{
          padding: "10px 12px",
          fontWeight: 700,
          textAlign: "right",
        }}
      >
        Grand Total
      </td>

      <td
        style={{
          padding: "10px 12px",
          textAlign: "right",
          fontWeight: 700,
        }}
      >
        {formatCurrency(totalCost)}
      </td>

      <td
        style={{
          padding: "10px 12px",
          textAlign: "right",
          fontWeight: 700,
        }}
      >
        100%
      </td>
    </tr>
  );

  const monthLabel =
    MONTH_OPTIONS.find((m) => m.value === month)?.label || month;

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = () => {
    pushToast?.("PDF export not implemented yet.", "info");
  };

  const handleExportExcel = () => {
    pushToast?.("Excel export not implemented yet.", "info");
  };

  return (
    <div className="invoice-printable">
      <InvoiceFilters
        month={month}
        year={year}
        onMonthChange={setMonth}
        onYearChange={setYear}
        onRefresh={fetchInvoice}
        onGenerate={fetchInvoice}
        loading={loading}
      />

      <InvoiceSummaryCards
        cards={[
          {
            title: "Total Cost",
            value: formatCurrency(totalCost),
            icon: "💰",
            accentColor: COLORS.aquaBlue,
            loading,
            error,
          },
          {
            title: "Total Quantity Used",
            value: totalQty,
            icon: "📦",
            accentColor: "#6366f1",
            loading,
            error,
          },
          {
            title: "Number of Items",
            value: itemCount,
            icon: "🧾",
            accentColor: COLORS.grassGreen,
            loading,
            error,
          },
          {
            title: "Average Cost / Item",
            value: formatCurrency(averageCost),
            icon: "📊",
            accentColor: COLORS.vividPurple,
            loading,
            error,
          },
        ]}
      />

      <Card>
        <SectionHeader
          title="Monthly Invoice"
          subtitle={`${monthLabel} ${year}`}
          accentColor={COLORS.aquaBlue}
          right={
            <div
              style={{
                display: "flex",
                gap: 10,
              }}
              className="no-print"
            >
              <SecondaryButton onClick={handlePrint}>
                🖨️ Print
              </SecondaryButton>

              <SecondaryButton onClick={handleDownloadPDF}>
                ⬇️ Download PDF
              </SecondaryButton>

              <SecondaryButton onClick={handleExportExcel}>
                📊 Export Excel
              </SecondaryButton>
            </div>
          }
        />

        <div style={{ padding: 16 }}>
          <InvoiceTable
            columns={columns}
            rows={items}
            loading={loading}
            error={error}
            onRetry={fetchInvoice}
            emptyMessage="No inventory usage found for this month."
            footer={items.length ? footer : null}
            rowKey="inventory_item_id"
          />
        </div>
      </Card>
    </div>
  );
};

export default MonthlyInvoice;